import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

const normalizeNewlines = (content) => content?.replaceAll('\\n', '\n');

export const sanitizeDom = (html) => {
  if (!html) return null;

  const normalized = normalizeNewlines(html);

  const htmlWithBreaks = normalized.replace(/\n/g, '<br/>');

  return DOMPurify.sanitize(htmlWithBreaks);
};

// Sanitizes an HTML string without the sanitizeDom newline->`<br/>` transform.
// Use for already-structured rich-text/HTML (survey answers, scorecard
// responses, job descriptions, LinkedIn previews) where preserving the
// original layout matters — it strips scripts/event-handlers/dangerous markup
// while leaving the rendered output otherwise unchanged.
// `config` is passed straight to DOMPurify — e.g. `{ ADD_ATTR: ['colwidth'] }` to
// keep the editor's non-standard table width attribute, which the default config
// strips. Omitted → default config.
export const sanitizeHtml = (html, config) =>
  DOMPurify.sanitize(html || '', config);

export const normalizeText = (text) => {
  if (!text) return '';

  return normalizeNewlines(text);
};
